module.exports = __webpack_public_path__ + "img/register_05.96b2ecb1.png";